import { render, staticRenderFns } from "./HolidaysCalenderView.vue?vue&type=template&id=519e5f45&"
import script from "./HolidaysCalenderView.vue?vue&type=script&lang=js&"
export * from "./HolidaysCalenderView.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysCalenderView.vue?vue&type=style&index=0&id=519e5f45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports